// API для взаємодії з Electron main process
class ElectronAPI {
  constructor() {
    this.isElectron = window.electronAPI !== undefined;
  }

  // Device Management
  async getDevices() {
    if (!this.isElectron) return [];
    try {
      return await window.electronAPI.invoke('get-devices');
    } catch (error) {
      console.error('Failed to get devices:', error);
      return [];
    }
  }

  async generateRegistrationCode(deviceInfo) {
    if (!this.isElectron) throw new Error('Electron API not available');
    return await window.electronAPI.invoke('generate-registration-code', deviceInfo);
  }

  async registerDevice(code) {
    if (!this.isElectron) throw new Error('Electron API not available');
    return await window.electronAPI.invoke('register-device', code);
  }

  async revokeDevice(deviceId) {
    if (!this.isElectron) throw new Error('Electron API not available');
    return await window.electronAPI.invoke('revoke-device', deviceId);
  }

  // Sync Management
  async getSyncStatus() {
    if (!this.isElectron) return { isOnline: false, pendingItems: 0 };
    try {
      return await window.electronAPI.invoke('get-sync-status');
    } catch (error) {
      console.error('Failed to get sync status:', error);
      return { isOnline: false, pendingItems: 0 };
    }
  }

  async getSyncHistory() {
    if (!this.isElectron) return [];
    try {
      return await window.electronAPI.invoke('get-sync-history');
    } catch (error) {
      console.error('Failed to get sync history:', error);
      return [];
    }
  }

  async forceSync() {
    if (!this.isElectron) throw new Error('Electron API not available');
    return await window.electronAPI.invoke('force-sync');
  }

  async clearSyncQueue() {
    if (!this.isElectron) throw new Error('Electron API not available');
    return await window.electronAPI.invoke('clear-sync-queue');
  }

  // Backup Management
  async createBackup() {
    if (!this.isElectron) throw new Error('Electron API not available');
    return await window.electronAPI.invoke('create-backup');
  }

  async getBackupHistory() {
    if (!this.isElectron) return [];
    try {
      return await window.electronAPI.invoke('get-backup-history');
    } catch (error) {
      console.error('Failed to get backup history:', error);
      return [];
    }
  }
}

export default new ElectronAPI();